// test918
(918 && 0);
